import React from "react";
import PropTypes from "prop-types";
import {ASelect, ASwitch} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import {t} from "i18next";
import {useSelector} from "react-redux";
import {
  selectEventsLoading,
  selectTotalEventsCount
} from "store/selectors/incidentDetectionSelectors";
import {EVENT_TYPE_OPTIONS, SEVERITY_OPTIONS} from "models/options";
import TooltipDelay from "../../../components/TooltipDelay";
import ImportantEventIcon from "../components/ImportantEventIcon";
import SourceSelect from "./SourceSelect";
import css from "./EventsTableToolbar.module.scss";

const EventsTableToolbar = ({
  importantOnly,
  setImportantOnly,
  selectedSources,
  setSelectedType,
  setSelectedSources,
  setSelectedSeverity,
  className
}) => {
  const isLoading = useSelector(selectEventsLoading);
  const totalEventsCount = useSelector(selectTotalEventsCount);

  return (
    <div
      className={classNames("d-flex justify-space-between", className)}
      data-testid={"DetectionTableToolbar"}>
      <div className="mt-1 mb-3">
        <ASelect
          medium
          className={classNames(css.select, "mr-2")}
          items={EVENT_TYPE_OPTIONS}
          itemText="title"
          itemValue="value"
          placeholder={t("detection.toolbar.type")}
          onSelected={(item) => setSelectedType(item)}
          disabled={isLoading || !totalEventsCount}
        />
        <SourceSelect
          selectedSources={selectedSources}
          setSelectedSources={setSelectedSources}
        />
        <ASelect
          medium
          className={classNames(css.select, "mr-2")}
          items={SEVERITY_OPTIONS}
          itemText="title"
          itemValue="value"
          placeholder={t("detection.toolbar.severity")}
          onSelected={(item) => setSelectedSeverity(item)}
          disabled={isLoading || !totalEventsCount}
        />
      </div>
      <TooltipDelay
        title={t("incidentDetail.detail.importantOnlyTooltipSwitch")}
        placement={"top-right"}>
        <ASwitch
          checked={importantOnly}
          onClick={() => setImportantOnly(!importantOnly)}
          disabled={isLoading || !totalEventsCount}>
          <ImportantEventIcon className={"mr-2"} />
          {t("detection.toolbar.importantText")}
        </ASwitch>
      </TooltipDelay>
    </div>
  );
};

EventsTableToolbar.propTypes = {
  importantOnly: PropTypes.bool,
  setImportantOnly: PropTypes.func,
  setSelectedType: PropTypes.func,
  setSelectedSource: PropTypes.func,
  setSelectedSeverity: PropTypes.func
};

export default EventsTableToolbar;
